import { View } from "react-native";
import { forwardRef, useImperativeHandle } from "react";
import { ModifyResidentRef } from "../interfaces";
import MedicalHistoryItem from "../../organisms/MedicalHistoryItem";
import { useHandleMedicalHistory } from "../../hooks/useHandleMedicalHistory";

const ResidentMedicalHistoryFormTemplate = forwardRef<ModifyResidentRef, {}>(
  (_, ref) => {
    const { control, errorMessage, submitForm } = useHandleMedicalHistory();

    useImperativeHandle(
      ref,
      () => ({
        continue: () => submitForm(),
      }),
      [submitForm],
    );

    return <MedicalHistoryItem control={control} errorMessage={errorMessage} />;
  },
);

ResidentMedicalHistoryFormTemplate.displayName =
  "ResidentMedicalHistoryFormTemplate";

export { ResidentMedicalHistoryFormTemplate };
